import React, { useState } from 'react';

interface Task {
  id: number;
  clientId: number;
  title: string;
  timeSpent: number; // בדקות
}

const sampleTasks: Task[] = [
  { id: 1, clientId: 1, title: 'משימה 1', timeSpent: 0 },
  { id: 2, clientId: 2, title: 'משימה 2', timeSpent: 30 },
];

export default function Tasks() {
  const [tasks, setTasks] = useState<Task[]>(sampleTasks);
  const [newTitle, setNewTitle] = useState('');
  const [newClientId, setNewClientId] = useState<number | ''>('');

  function addTask() {
    if (!newTitle || !newClientId) return alert('מלא את כל השדות');
    const newTask: Task = {
      id: tasks.length + 1,
      clientId: Number(newClientId),
      title: newTitle,
      timeSpent: 0,
    };
    setTasks([...tasks, newTask]);
    setNewTitle('');
    setNewClientId('');
  }

  return (
    <div>
      <h2>משימות</h2>
      <div>
        <input
          type="text"
          placeholder="כותרת משימה"
          value={newTitle}
          onChange={e => setNewTitle(e.target.value)}
          style={inputStyle}
        />
        <input
          type="number"
          placeholder="מספר לקוח"
          value={newClientId}
          onChange={e => setNewClientId(Number(e.target.value))}
          style={inputStyle}
          min={1}
        />
        <button onClick={addTask} style={btnStyle}>הוסף משימה</button>
      </div>

      <ul>
        {tasks.map(task => (
          <li key={task.id}>
            <b>{task.title}</b> - לקוח #{task.clientId} - זמן עבודה: {task.timeSpent} דקות
          </li>
        ))}
      </ul>
    </div>
  );
}

const inputStyle = {
  margin: '5px',
  padding: '5px',
  fontSize: '1rem',
};

const btnStyle = {
  backgroundColor: '#0052cc',
  color: 'white',
  border: 'none',
  padding: '6px 12px',
  cursor: 'pointer',
};
